import { render, staticRenderFns } from "./TimeDetection.vue?vue&type=template&id=669ff44c&scoped=true"
import script from "./TimeDetection.vue?vue&type=script&lang=js"
export * from "./TimeDetection.vue?vue&type=script&lang=js"
import style0 from "./TimeDetection.vue?vue&type=style&index=0&id=669ff44c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ff44c",
  null
  
)

export default component.exports